import { View } from '@ninjacart/nc-nk-ui';
import dynamic from 'next/dynamic';
import React, { memo } from 'react';
import { AdaptiveCarousel } from '../components/carousel/adaptiveCarousel';
// import { FeedListCard } from './homeScreen/feedShortsListCard';
import { FeedItem } from './home/feedItem';
// import { HomeLangaugeBanner } from './homeScreen/homeLanguageBanner';
import { ImageAdCard } from './homeScreen/imageAdCard';
import { WebWidget } from './homeScreen/webWidget';

// const LazyAdaptiveCarousel = dynamic(
//   () => import('../components/carousel/adaptiveCarousel').then((mod) => mod.AdaptiveCarousel),
//   { ssr: true }
// );

const LazyBannerAds = dynamic(
  () => import('@ninjacart/nc-nk-web-deps').then((mod) => mod.BannerAds),
  { ssr: false }
);

const LazyAnimalsListCard = dynamic(
  () => import('./crops/animalsCard').then((mod) => mod.AnimalsListCard),
  { ssr: false }
);

const LazyCropsSelectionCard = dynamic(
  () => import('./crops/cropsCard').then((mod) => mod.CropsSelectionCard),
  { ssr: false }
);

const LazyVideoTab = dynamic(() => import('./discovery/videoTab').then((mod) => mod.VideoTab), {
  ssr: false,
});

const LazyFeedListCard = dynamic(
  () => import('./homeScreen/feedShortsListCard').then((mod) => mod.FeedListCard),
  { ssr: false }
);

const LazyPWAInstallPrompt = dynamic(
  () => import('./homeScreen/pwaInstallPromptCard').then((mod) => mod.PWAInstallPrompt),
  { ssr: false }
);

const LazyHomeLanguageBanner = dynamic(
  () => import('./homeScreen/homeLanguageBanner').then((mod) => mod.HomeLangaugeBanner),
  { ssr: false }
);

const LazyProductItemRenderComponent = dynamic(
  () =>
    import('./products/allProductRenderComponent/renderAllProductComponent').then(
      (mod) => mod.ProductItemRenderComponent
    ),
  { ssr: false }
);

const LazyQuestionAnswerCard = dynamic(
  () => import('./qna/questionAnswerCard').then((mod) => mod.QuestionAnswerCard),
  { ssr: false }
);
240;
const LazyWeatherUiCard = dynamic(
  () => import('./weather/weatherUiCard').then((mod) => mod.WeatherUiCard),
  { ssr: false }
);

// const LazyWebWidget = dynamic(() => import('./homeScreen/webWidget').then((mod) => mod.WebWidget), {
//   ssr: true,
// });

// const LazyImageAdCard = dynamic(
//   () => import('./homeScreen/imageAdCard').then((mod) => mod.ImageAdCard),
//   { ssr: true }
// );

const LazyFeedItem = dynamic(() => import('./home/feedItem').then((mod) => mod.FeedItem), {
  ssr: false,
});

interface AdaptiveCardRendererProps {
  name: string;
  item?: any;
  index?: number;
  [key: string]: any;
}

const componentMap: {
  [key: string]: React.ComponentType<any>;
} = {
  carousel: AdaptiveCarousel,
  STREAM: FeedItem,
  LANGUAGE: LazyHomeLanguageBanner,
  ANIMAL: LazyAnimalsListCard,
  SHORTS: LazyFeedListCard,
  CROP: LazyCropsSelectionCard,
  WEATHER: LazyWeatherUiCard,
  ANCHORED_ADAPTIVE_BANNER: LazyBannerAds,
  INLINE_ADAPTIVE_BANNER: LazyBannerAds,
  INFEED_AD_1: LazyBannerAds,
  INFEED_AD_2: LazyBannerAds,
  INFEED_AD_3: LazyBannerAds,
  BANNER_AD: LazyBannerAds,
  'trending-videos': LazyVideoTab,
  'continue-watching': LazyVideoTab,
  'marketing-videos': LazyVideoTab,
  'crop-videos': LazyVideoTab,
  'tractor-videos': LazyVideoTab,
  'crop-playlists': LazyVideoTab,
  'animal-playlists': LazyVideoTab,
  'machinery-playlists': LazyVideoTab,
  'govt-scheme-playlists': LazyVideoTab,
  Popular: LazyVideoTab,
  Expert: LazyVideoTab,
  Dairy: LazyVideoTab,
  'video-list': LazyVideoTab,
  Trending: LazyVideoTab,
  'product-subcategories': LazyProductItemRenderComponent,
  'product-categories': LazyProductItemRenderComponent,
  'product-banner': LazyProductItemRenderComponent,
  'product-list': LazyProductItemRenderComponent,
  'product-grid': LazyProductItemRenderComponent,
  'product-highlights': LazyProductItemRenderComponent,
  'product-trending': LazyProductItemRenderComponent,
  'provider-list': LazyProductItemRenderComponent,
  'my-courses-list': LazyProductItemRenderComponent,
  QNA: LazyQuestionAnswerCard,
  'web-widget': WebWidget,
  'ipl-iframe-widget': WebWidget,
  PWA: LazyPWAInstallPrompt,
  INFEED_BANNER_ITEM: ImageAdCard,
};

const estimatedItemHeights = {
  carousel: 210,
  STREAM: 360,
  LANGUAGE: 150,
  ANIMAL: 120,
  SHORTS: 380,
  CROP: 120,
  WEATHER: 150,
  'trending-videos': 300,
  'continue-watching': 300,
  'marketing-videos': 300,
  'crop-videos': 300,
  'tractor-videos': 300,
  'crop-playlists': 300,
  'animal-playlists': 300,
  'machinery-playlists': 300,
  'govt-scheme-playlists': 300,
  Popular: 300,
  Expert: 300,
  Dairy: 300,
  'video-list': 300,
  Trending: 300,
  'product-subcategories': 240,
  'product-categories': 240,
  'product-banner': 240,
  'product-list': 240,
  'product-grid': 240,
  'product-highlights': 240,
  'product-trending': 240,
  'provider-list': 240,
  'my-courses-list': 240,
  QNA: 300,
  'web-widget': 300,
  'ipl-iframe-widget': 300,
  INFEED_BANNER_ITEM: 180,
};

export const BaseAdaptiveCardRenderer = memo(
  ({ name, item, index, ...rest }: AdaptiveCardRendererProps) => {
    const Component = componentMap[name];

    if (!Component) {
      console.error(`Component for cardType "${name}" not found.`);
      return <></>;
    }

    const estimatedItemHeight = estimatedItemHeights[name] ?? 200;
    // const isDynamicHeight = dynamicHeightItems.some((x) => x === name) ?? false;
    // console.log('🚀 ~ estimatedItemHeight for card:', estimatedItemHeight);

    return (
      <View flex={1} minHeight={estimatedItemHeight}>
        <Component item={item} index={index} {...rest} />
      </View>
    );
  }
);
